/**
 * Theme image / visual search: modal upload + API response (product cards or redirect).
 */
(function () {
  'use strict';

  var ACCEPT_EXT = /\.(jpe?g|png|webp)$/i;
  // var ACCEPT_MIME = /^image\/(jpeg|png|webp)$/i;
  var ACCEPT_MIME = /^image\/(jpeg|png|webp|heic|heif)$/i;

  var FALLBACK_VISUAL_SEARCH_API =
    'https://api.wizsearch.in/v1/products/visual-search';


  function setSelectedFile(root, file) {
    root.__selectedFile = file;
  }

  function setFile(root, file) {
    root.__selectedFile = file;
    setSelectedFile(root, file); // keep backward compatibility
  }

  /**
   * @param {File} file
   * @returns {boolean}
   */
  function isAllowedImage(file) {
    if (!file) return false;
    var name = file.name || '';
    if (file.type && ACCEPT_MIME.test(file.type)) return true;
    return ACCEPT_EXT.test(name);
  }

  /**
   * @param {string} url
   */
  function navigateTo(url) {
    if (!url) return;
    window.location.href = url;
  }

  /**
   * @param {string} href
   * @returns {boolean}
   */
  function isSafeNavHref(href) {
    if (!href) return false;
    if (href.indexOf('/') === 0 && href.indexOf('//') !== 0) return true;
    try {
      var u = new URL(href, window.location.origin);
      return u.protocol === 'https:' || u.protocol === 'http:';
    } catch (_) {
      return false;
    }
  }

  /**
   * @param {string} url
   * @returns {string}
   */
  function safeImageSrc(url) {
    if (!url || typeof url !== 'string') return '';
    var u = url.trim();
    if (/^https?:\/\//i.test(u)) return u;
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.indexOf('/') === 0) return u;
    return '';
  }

  /**
   * @param {HTMLElement} root
   */
  function revokePreviewBlobUrl(root) {
    var prev = root.dataset.previewObjectUrl;
    if (!prev) return;
    try {
      URL.revokeObjectURL(prev);
    } catch (_) {}
    delete root.dataset.previewObjectUrl;
  }

  /**
   * @param {Record<string, unknown>} p
   * @returns {string}
   */
  function pickImageUrl(p) {
    if (!p || typeof p !== 'object') return '';
    var cand = p.image || p.mainImage || p.thumbnail || p.featured_image || p.featuredImage;
    if (typeof cand === 'string') return safeImageSrc(cand);
    if (cand && typeof cand === 'object') {
      var o = /** @type {Record<string, unknown>} */ (cand);
      if (typeof o.src === 'string') return safeImageSrc(o.src);
      if (typeof o.url === 'string') return safeImageSrc(o.url);
    }
    return '';
  }

  /**
   * @param {Record<string, unknown>} p
   * @returns {string}
   */
  function pickTitle(p) {
    if (!p || typeof p !== 'object') return 'Product';
    var t = p.title || p.name || p.product_name || p.productTitle;
    if (typeof t === 'string' && t.trim()) return t.trim();
    return 'Product';
  }

  /**
   * @param {unknown} v
   * @returns {string}
   */
  function formatPriceValue(v) {
    if (v == null || v === '') return '';
    if (typeof v === 'string') return v.trim();
    if (typeof v === 'number' && isFinite(v)) return String(v);
    return String(v);
  }

  /**
   * @param {Record<string, unknown>} p
   * @returns {{ compare: string, current: string }}
   */
  function pickPrices(p) {
    if (!p || typeof p !== 'object') return { compare: '', current: '' };
    var compare = formatPriceValue(
      p.compare_at_price != null ? p.compare_at_price : p.compareAtPrice
    );
    var current = formatPriceValue(
       p.sellingPrice != null
        ? p.sellingPrice
        : p.price != null
          ? p.price
          : p.minPrice != null
            ? p.minPrice
            : p.formatted_price
    );
    return { compare: compare, current: current };
  }

  /**
   * @param {Record<string, unknown>} p
   * @returns {string}
   */
  function resolveProductHref(p) {
    if (!p || typeof p !== 'object') return '';
    var url = p.url || p.product_url || p.link || p.onlineStoreUrl;
    if (typeof url === 'string' && url.trim()) {
      var t = url.trim();
      if (isSafeNavHref(t)) return t;
    }
    var handle = p.handle || p.product_handle;
    if (typeof handle === 'string' && handle.trim()) {
      return '/products/' + encodeURIComponent(handle.trim());
    }
    return '';
  }

  /**
   * Extract a Shopify product handle from API fields or a product URL.
   * @param {Record<string, unknown>} p
   * @param {string} [href]
   * @returns {string}
   */
  function resolveProductHandle(p, href) {
    if (p && typeof p === 'object') {
      var rawHandle = p.handle || p.product_handle;
      if (typeof rawHandle === 'string' && rawHandle.trim()) {
        return rawHandle.trim();
      }
    }
    if (typeof href === 'string' && href.trim()) {
      try {
        var path = new URL(href, window.location.origin).pathname;
        var match = path.match(/\/products\/([^/?#]+)/);
        if (match && match[1]) {
          return decodeURIComponent(match[1]);
        }
      } catch (err) {
        /* ignore invalid href */
      }
    }
    return '';
  }

  /**
   * @param {Record<string, unknown>} raw
   */
  function normalizeProduct(raw) {
    if (!raw || typeof raw !== 'object') {
      return { title: 'Product', href: '', imageUrl: '', comparePrice: '', price: '', handle: '' };
    }
    var p = /** @type {Record<string, unknown>} */ (raw);
    var prices = pickPrices(p);
    var href = resolveProductHref(p);

    return {
        title: pickTitle(p),
        href: href,
        handle: resolveProductHandle(p, href),
        imageUrl: pickImageUrl(p),
        comparePrice: prices.compare,
        price: prices.current,

        productId:
            p.groupId ||
            p.productId ||
            p.product_id ||
            p.id,

        variantId:
            p.variantId ||
            p.variant_id ||
            p.defaultVariantId ||
            p.id,

        // Do not use Shopify/Wizzy inStock for storefront availability.
        // WMS owns ATC; keep cards openable for Quick View.
        available: true,

        optionsCount:
            p.optionsCount ||
            p.options_count ||
            1,

        recommendationScore: Number(p.recommendationScore || 0)
    };
  }

  function createQuickAdd(product) {

    const template = document.getElementById("quick-add-template");

    if (!template)
        return document.createDocumentFragment();

    const node = template.content.cloneNode(true);

    const quickAdd =
        node.querySelector("quick-add-component");

    const productForm =
        node.querySelector("product-form-component");

    const variantInput =
        node.querySelector(".js-variant-id");

    const productIdInput =
        node.querySelector(".js-product-id");

    const form =
        node.querySelector("form");

    const atcBtn =
        node.querySelector(".js-atc-btn");

    const inStockText =
        node.querySelector(".js-atc-text-instock");

    const soldOutText =
        node.querySelector(".js-atc-text-soldout");

    const addToCartComponent =
        node.querySelector("add-to-cart-component");

    if (!quickAdd || !productForm) {
      return document.createDocumentFragment();
    }

    // WMS owns availability. Start disabled; product-form WMS sync enables when available.
    const isAvailable = false;

    quickAdd.dataset.productTitle =
        product.title;

    quickAdd.dataset.productOptionsCount =
        product.optionsCount || 1;

    quickAdd.dataset.productAvailable = 'false';
    if (productForm) {
      productForm.dataset.wmsVariantSku = String(product.sku || product.variantSku || '').trim();
      productForm.dataset.productId = String(product.productId || productForm.dataset.productId || '');
    }

    productForm.dataset.productId =
        product.productId || '';

    productForm.dataset.sectionId =
        "visual-search";

    if (variantInput) {
      variantInput.value = product.variantId || '';
    }

    if (productIdInput) {
      productIdInput.value = product.productId || '';
    }

    if (addToCartComponent && product.imageUrl) {
      addToCartComponent.dataset.productVariantMedia = product.imageUrl;
    }

    var formId = "VisualSearch-" + (product.variantId || product.productId || Date.now());
    if (form) {
      form.id = formId;
    }

    if (atcBtn) {
      atcBtn.classList.toggle('plp-card__atc--active', isAvailable);
      atcBtn.classList.toggle('plp-card__atc--disabled', !isAvailable);
      if (isAvailable) {
        atcBtn.removeAttribute('disabled');
      } else {
        atcBtn.setAttribute('disabled', '');
      }
    }

    if (inStockText) {
      inStockText.hidden = !isAvailable;
    }
    if (soldOutText) {
      soldOutText.hidden = isAvailable;
    }

    // Prevent parent <a> card navigation when interacting with ATC
    if (quickAdd) {
      quickAdd.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    return node;
  }

  /**
   * @param {Record<string, unknown>} data
   * @returns {unknown[]}
   */
  function extractProductsArray(data) {
    if (!data || typeof data !== 'object') return [];
    var d = /** @type {Record<string, unknown>} */ (data);
    var payload = d.payload;
    if (payload && typeof payload === 'object') {
      var pl = /** @type {Record<string, unknown>} */ (payload);
      if (Array.isArray(pl.result)) return pl.result;
      if (Array.isArray(pl.products)) return pl.products;
    }
    if (Array.isArray(d.data)) return d.data;
    if (Array.isArray(d.products)) return d.products;
    if (Array.isArray(d.result)) return d.result;
    if (Array.isArray(d.items)) return d.items;
    return [];
  }

  /**
   * @param {HTMLElement} root
   */
  function clearVisualSearchResults(root) {
    var wrap = root.querySelector('[data-image-search-results]');
    var grid = root.querySelector('[data-image-search-results-grid]');
    var titleEl = root.querySelector('[data-image-search-results-title]');
    if (wrap) wrap.hidden = true;
    if (grid) grid.innerHTML = '';
    if (titleEl) titleEl.textContent = '';
  }

  function createProductCard(product) {
    var card = document.createElement('a');
    card.className = 'image-search__product-card';
    card.href = product.href;
    card.setAttribute('aria-label', product.title);
    if (product.handle) {
      card.setAttribute('data-product-handle', product.handle);
    }
    card.setAttribute('data-product-available', 'true');

    var media = document.createElement('div');
    media.className = 'image-search__product-media';

    if (product.imageUrl) {
      var img = document.createElement('img');
      img.className = 'image-search__product-img';
      img.src = product.imageUrl;
      img.alt = product.title;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    } else {
      var ph = document.createElement('span');
      ph.className = 'image-search__product-placeholder';
      ph.textContent = '-';
      media.appendChild(ph);
    }

    if (product.recommendationScore > 0) {
      var badge = document.createElement('span');
      badge.className = 'image-search__recommendation-badge';
      badge.textContent = Math.round(product.recommendationScore * 100) + '% Match';
      media.appendChild(badge);
    }

    // if (!product.available) {
    //   var soldOutBadge = document.createElement('span');
    //   soldOutBadge.className = 'plp-card__badge plp-card__badge--soldout image-search__soldout-badge';
    //   soldOutBadge.textContent = 'Sold out';
    //   media.appendChild(soldOutBadge);
    // }

    var nameEl = document.createElement('p');
    nameEl.className = 'image-search__product-name';
    nameEl.textContent = product.title;

    var priceRow = document.createElement('div');
    priceRow.className = 'image-search__product-prices';

    if (
      product.comparePrice &&
      product.price &&
      product.comparePrice !== product.price
    ) {
      var cmp = document.createElement('span');
      cmp.className =
        'image-search__product-price image-search__product-price--compare';
      cmp.textContent = product.comparePrice;
      priceRow.appendChild(cmp);
    }

    if (product.price) {
      var cur = document.createElement('span');
      cur.className = 'image-search__product-price';
      cur.textContent = product.price;
      priceRow.appendChild(cur);
    }

    var shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'image-search__share-btn';
    shareBtn.setAttribute('aria-label', 'Share Product');

    shareBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2">
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <path d="M8.59 13.51L15.42 17.49M15.41 6.51L8.59 10.49"></path>
    </svg>`;

    shareBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      var productUrl = new URL(product.href, window.location.origin).href;

      var isMobile =
          /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(
              navigator.userAgent
          );

      // Mobile: only open native share sheet
      if (isMobile && navigator.share) {
          try {
              await navigator.share({
                  title: product.title,
                  url: productUrl
              });
          } catch (_) {
              // User cancelled sharing
          }
          return;
      }

      // Desktop: copy link and show tooltip
      try {
          await navigator.clipboard.writeText(productUrl);
          showCopiedTooltip(shareBtn);
      } catch (_) {
          try {
              var input = document.createElement('input');
              input.value = productUrl;
              document.body.appendChild(input);
              input.select();
              document.execCommand('copy');
              document.body.removeChild(input);

              showCopiedTooltip(shareBtn);
          } catch (_) {}
      }
    });

    media.appendChild(shareBtn);

    card.appendChild(media);
    card.appendChild(nameEl);
    card.appendChild(priceRow);
    card.appendChild(createQuickAdd(product));

    initializeQuickAdd(card);

    return card;
  }


  function initializeQuickAdd(root) {

    if (!root) return;

    root.querySelectorAll("quick-add-component")
        .forEach(component => {

            if (component.connectedCallback) {
                component.connectedCallback();
            }
        });

    root.querySelectorAll("product-form-component")
        .forEach(component => {

            if (component.connectedCallback) {
                component.connectedCallback();
            }
        });

    root.querySelectorAll("add-to-cart-component")
        .forEach(component => {

            if (component.connectedCallback) {
                component.connectedCallback();
            }
        });

  }

  /**
   * @param {HTMLElement} root
   * @param {unknown[]} productsRaw
   * @returns {boolean} true when at least one product card was shown
   */
  function clearVisualSearchResults(root) {
    var wrap = root.querySelector('[data-image-search-results]');
    var section = root.querySelector('[data-image-search-results-section]');
    var grid = root.querySelector('[data-image-search-results-grid]');
    var titleEl = root.querySelector('[data-image-search-results-title]');

    if (wrap) wrap.hidden = true;
    if (section) section.hidden = true;
    if (grid) grid.innerHTML = '';
    if (titleEl) titleEl.textContent = '';
  }

  function showCopiedTooltip(button) {
    let tooltip = button.querySelector(".image-search__share-tooltip");

    if (!tooltip) {
        tooltip = document.createElement("span");
        tooltip.className = "image-search__share-tooltip";
        tooltip.textContent = "Copied";
        button.appendChild(tooltip);
    }

    // Reset animation if already visible
    tooltip.classList.remove("is-visible");

    // Force browser reflow
    void tooltip.offsetWidth;

    tooltip.classList.add("is-visible");

    if (button.__tooltipTimeout) {
        clearTimeout(button.__tooltipTimeout);
    }

    button.__tooltipTimeout = setTimeout(function () {
        tooltip.classList.remove("is-visible");
    }, 1000);
  }

  /**
   * @param {HTMLElement} root
   * @param {string} msg
   */
  function showError(root, msg) {
    var box = root.querySelector('[data-image-search-error]');
    if (!box) return;
    box.hidden = false;
    box.textContent = msg || '';
  }

  /**
   * @param {HTMLElement} root
   */
  function hideError(root) {
    var box = root.querySelector('[data-image-search-error]');
    if (!box) return;
    box.hidden = true;
    box.textContent = '';
  }

  /**
   * @param {HTMLElement} root
   * @param {string} msg
   */
  function showStatus(root, msg) {
    var el = root.querySelector('[data-image-search-status]');
    if (!el) return;
    el.hidden = !msg;
    el.textContent = msg || '';
  }

  /**
   * @param {HTMLElement} root
   */
  function clearSelectedFile(root, input, previewWrap, placeholder, previewImg, fileNameEl) {
    revokePreviewBlobUrl(root);
    input.value = '';
    root.dataset.selectedFileName = '';
    if (previewImg) {
        previewImg.src = '';
        previewImg.removeAttribute('src');
        previewImg.removeAttribute('srcset');
        previewImg.removeAttribute('alt');
        previewImg.load && previewImg.load();
    }
    if (fileNameEl) {
        fileNameEl.textContent = '';
    }
    if (previewWrap) {
        previewWrap.hidden = true;
    }
    if (placeholder) {
        placeholder.hidden = false;
    }
    delete root.__selectedFile;
  }

  /**
   * @param {HTMLElement} root
   * @param {File} file
   */
  function showPreview(root, file, previewWrap, placeholder, previewImg, fileNameEl) {
    if (!previewWrap || !previewImg || !placeholder) return;
    revokePreviewBlobUrl(root);
    var url = URL.createObjectURL(file);
    root.dataset.previewObjectUrl = url;
    previewImg.src = url;
    previewImg.alt = file.name || '';
    if (fileNameEl) fileNameEl.textContent = file.name || '';
    placeholder.hidden = true;
    previewWrap.hidden = false;
  }

  function renderVisualSearchResults(root, productsRaw) {
    clearVisualSearchResults(root);

    var wrap = root.querySelector('[data-image-search-results]');
    var section = root.querySelector('[data-image-search-results-section]');
    var grid = root.querySelector('[data-image-search-results-grid]');
    var titleEl = root.querySelector('[data-image-search-results-title]');

    if (!wrap || !section || !grid) {
      return false;
    }

    var heading = (root.dataset.resultsHeading || '').trim();

    productsRaw.forEach(function (raw) {
      if (!raw || typeof raw !== 'object') return;

      var product = normalizeProduct(raw);
      if (!product.href) return;

      grid.appendChild(createProductCard(product));
    });

    if (!grid.children.length) {
      return false;
    }

    if (titleEl && heading) titleEl.textContent = heading;
    section.hidden = false;
    wrap.hidden = false;

    if (window.innerWidth < 750) {
      wrap.classList.remove('is-expanded');
      wrap.classList.add('is-open');
    }

    return true;
  }

  /**
   * @param {Record<string, unknown>} data
   * @param {HTMLElement} root
   * @returns {{ navigatedAway: boolean }}
   */
  function handleApiSuccess(data, root) {
    var noResult = root.dataset.noResultMessage || '';
    var mode = (root.dataset.redirectMode || 'flexible').trim();

    if (!data || typeof data !== 'object') {
      showError(root, noResult);
      return { navigatedAway: false };
    }

    if (data.success === false) {
      var failMsg = typeof data.message === 'string' ? data.message : noResult;
      showError(root, failMsg || noResult);
      return { navigatedAway: false };
    }

    var productsRaw = extractProductsArray(data);
    if (productsRaw.length) {
      var shown = renderVisualSearchResults(root, productsRaw);
      if (shown) {
        hideError(root);
        return { navigatedAway: false };
      }
    }

    var redirectUrl = typeof data.redirect_url === 'string' ? data.redirect_url.trim() : '';
    var searchQuery =
      typeof data.search_query === 'string' ? data.search_query.trim() : '';

    var handles = Array.isArray(data.product_handles) ? data.product_handles : null;
    var ids = Array.isArray(data.product_ids) ? data.product_ids : null;

    if (mode === 'redirect_only') {
      if (redirectUrl) {
        navigateTo(redirectUrl);
        return { navigatedAway: true };
      }
      showError(root, noResult);
      return { navigatedAway: false };
    }

    if (redirectUrl) {
      navigateTo(redirectUrl);
      return { navigatedAway: true };
    }

    if (searchQuery) {
      var searchBase = root.dataset.searchUrl || '/search';
      try {
        var u = new URL(searchBase, window.location.origin);
        u.searchParams.set('q', searchQuery);
        navigateTo(u.pathname + u.search + u.hash);
      } catch (_) {
        navigateTo(searchBase + (searchBase.indexOf('?') >= 0 ? '&' : '?') + 'q=' + encodeURIComponent(searchQuery));
      }
      return { navigatedAway: true };
    }

    if ((handles && handles.length) || (ids && ids.length)) {
      var resultsBase = root.dataset.resultsPageUrl || '/search';
      try {
        var ru = new URL(resultsBase, window.location.origin);
        if (handles && handles.length) {
          ru.searchParams.set('handles', handles.map(String).join(','));
        }
        if (ids && ids.length) {
          ru.searchParams.set('product_ids', ids.map(String).join(','));
        }
        navigateTo(ru.pathname + ru.search + ru.hash);
      } catch (_) {
        showError(root, noResult);
        return { navigatedAway: false };
      }
      return { navigatedAway: true };
    }

    showError(root, noResult);
    return { navigatedAway: false };
  }

  /**
   * @param {HTMLElement} root
   */
  function init(root) {
    if (!(root instanceof HTMLElement)) return;

    var rootId = root.id || '';
    var dialog = root.querySelector('[data-image-search-dialog]');
    var closeBtn = root.querySelector('[data-image-search-close]');
    var dropzone = root.querySelector('[data-image-search-dropzone]');
    var input = root.querySelector('[data-image-search-input]');
    var placeholder = root.querySelector('[data-image-search-placeholder]');
    var previewWrap = root.querySelector('[data-image-search-preview-wrap]');
    var previewImg = root.querySelector('[data-image-search-preview-img]');
    var fileNameEl = root.querySelector('[data-image-search-file-name]');
    var changeBtn = root.querySelector('[data-image-search-change]');
    var submitBtn = root.querySelector('[data-image-search-submit]');

    var drawer = root.querySelector('[data-image-search-results]');
    var drawerHandle = root.querySelector('[data-image-search-drawer-handle]');

    if (drawer && drawerHandle) {
      var startY = 0;
      
      function expandDrawer() {
        drawer.classList.add('is-expanded');
      }

      function collapseDrawer() {
        drawer.classList.remove('is-expanded');
      }
      
      drawerHandle.addEventListener('click', function () {
        if (drawer.classList.contains('is-expanded')) {
          collapseDrawer();
        } else {
          expandDrawer();
        }
      });

      drawerHandle.addEventListener('touchstart', function (e) {
        startY = e.touches[0].clientY;
      });
      
      drawerHandle.addEventListener('touchend', function (e) {
        var endY = e.changedTouches[0].clientY;
        var diff = endY - startY;
        
        if (diff < -50) {
          expandDrawer();
        }
        else if (diff > 50) {
          collapseDrawer();
        }
      });
    }

    if (!dialog || !(dialog instanceof HTMLDialogElement) || !input || !submitBtn) return;

    var submitDefaultText = submitBtn.textContent || '';

    function getOpenButtons() {
      var list = [];
      root.querySelectorAll('[data-image-search-open]:not([data-image-search-target])').forEach(function (b) {
        list.push(b);
      });
      if (rootId) {
        document.querySelectorAll('[data-image-search-open][data-image-search-target]').forEach(function (b) {
          if (b.getAttribute('data-image-search-target') === rootId) list.push(b);
        });
      }
      return list;
    }

    function setAllExpanded(expanded) {
      getOpenButtons().forEach(function (b) {
        b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closeModal() {
      if (dialog.open) dialog.close();
    }

    function lockBackgroundScroll() {
      document.documentElement.classList.add('image-search-dialog-open');
    }

    function unlockBackgroundScroll() {
      document.documentElement.classList.remove('image-search-dialog-open');
    }

    function resetImageSearchModal() {
      hideError(root);
      showStatus(root, '');

      clearSelectedFile(
          root,
          input,
          previewWrap,
          placeholder,
          previewImg,
          fileNameEl
      );

      clearVisualSearchResults(root);

      var drawer = root.querySelector('[data-image-search-results]');

      if (drawer) {
          drawer.classList.remove('is-open');
          drawer.classList.remove('is-expanded');
      }

      submitBtn.disabled = false;
      submitBtn.textContent = submitDefaultText;

      delete root.__selectedFile;
      delete root.dataset.selectedFileName;

      if (previewWrap) previewWrap.hidden = true;
      if (placeholder) placeholder.hidden = false;
    }

    /**
     * @param {HTMLElement | null} fromBtn
     */
    function openModal(fromBtn) {
      resetImageSearchModal();
      if (fromBtn && fromBtn.id) {
          dialog.dataset.lastTriggerId = fromBtn.id;
      }

      try {
          dialog.showModal();
          lockBackgroundScroll();
          setAllExpanded(true);
      } catch (_) {}
    }

    dialog.addEventListener('close', function () {
      // Quick view suspends this dialog (close + show) without clearing results
      if (dialog.dataset.suspended === 'true') return;
      unlockBackgroundScroll();
      setAllExpanded(false);
      var tid = dialog.dataset.lastTriggerId || '';
      var ref = tid ? document.getElementById(tid) : null;
      if (ref && typeof ref.focus === 'function') {
        try {
          ref.focus();
        } catch (_) {}
      }
      delete dialog.dataset.lastTriggerId;
      resetImageSearchModal();
      input.type = '';
      input.type = 'file';
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeModal();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeModal();
    });

    getOpenButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    function validateAndSetFile(file) {
      hideError(root);
      clearVisualSearchResults(root);
      var invalidMsg = root.dataset.invalidFileError || '';
      var sizeMsg = root.dataset.fileSizeError || '';
      var maxMb = parseInt(root.dataset.maxFileSizeMb || '5', 10);
      if (!isFinite(maxMb) || maxMb < 1) maxMb = 5;

      if (!isAllowedImage(file)) {
        showError(root, invalidMsg);
        return;
      }

      var maxBytes = maxMb * 1024 * 1024;
      if (file.size > maxBytes) {
        showError(root, sizeMsg);
        return;
      }

      showPreview(root, file, previewWrap, placeholder, previewImg, fileNameEl);
      root.dataset.selectedFileName = file.name || '';
      setFile(root, file);
    }

    if (dropzone && input) {
      dropzone.addEventListener('click', function () {
        input.click();
      });

      dropzone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          input.click();
        }
      });

      dropzone.addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.add('is-dragover');
      });

      dropzone.addEventListener('dragleave', function () {
        dropzone.classList.remove('is-dragover');
      });

      dropzone.addEventListener('drop', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropzone.classList.remove('is-dragover');
        var files = e.dataTransfer && e.dataTransfer.files;
        if (files && files.length) {
          input.files = files; // <-- important
          validateAndSetFile(files[0]);
        }
          // validateAndSetFile(files[0]);
      });

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        // var file = root.__selectedFile || (input.files && input.files[0]);
        if (file) validateAndSetFile(file);
      });
    }

    if (changeBtn && input) {
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        hideError(root);
        input.value = '';
        delete root.__selectedFile;
        input.click();
      });
    }

    submitBtn.addEventListener('click', function () {
      hideError(root);
      showStatus(root, '');
      clearVisualSearchResults(root);

      var apiUrl = (root.dataset.imageSearchApiUrl || '').trim();
      if (!apiUrl) apiUrl = FALLBACK_VISUAL_SEARCH_API;

      var apiMissing = root.dataset.apiMissingMessage || '';
      var networkErr = root.dataset.networkError || '';
      var noFileMsg = root.dataset.noFileMessage || '';
      var loadingText = root.dataset.loadingText || '';

      // var file = input.files && input.files[0];
      var file = root.__selectedFile || (input.files && input.files[0]);
      if (!file) {
        showError(root, noFileMsg || '');
        return;
      }

      if (!apiUrl) {
        showError(root, apiMissing);
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = loadingText || submitDefaultText;

      var fd = new FormData();
      fd.append('image', file);
      fd.append(
        'productsCount', 50
        
      );
      fd.append(
        'sort', [{ field: 'relevance', order: 'asc' }]
      );
      fd.append(
          'includeOutOfStock', true
        );

      try {
        var shop = window.Shopify && window.Shopify.shop ? String(window.Shopify.shop) : '';
        if (shop) fd.append('shop', shop);
      } catch (_) {}

      fetch(apiUrl, {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'x-store-id': '1fc10df67ad011f181180a0c8095feae',
          'x-api-key':
            'QVA4WG1EUmU5VVE1N2I0WUd5Y3hFS0lFTkxqRjZzbmQzNkdYaC9GTG4zR0taS29kZnJlNFF4ZlBaaURIYWdmR3ppc0R2T3lPMlJJbHhVR25HVGtLSVN0a3NkTkFURWZSZGxSZWd0QVhxNUk9',
        },
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var json = null;
            if (text) {
              try {
                json = JSON.parse(text);
              } catch (_) {
                throw new Error('invalid_json');
              }
            }
            return { ok: res.ok, json: json };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var msg =
              result.json &&
              typeof result.json === 'object' &&
              result.json.message &&
              typeof result.json.message === 'string'
                ? result.json.message
                : networkErr;
            showError(root, msg || networkErr);
            submitBtn.disabled = false;
            submitBtn.textContent = submitDefaultText;
            return;
          }
          var outcome = handleApiSuccess(
            result.json && typeof result.json === 'object'
              ? /** @type {Record<string, unknown>} */ (result.json)
              : {},
            root
          );
          if (!outcome.navigatedAway) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitDefaultText;
          }
        })
        .catch(function () {
          showError(root, networkErr);
          submitBtn.disabled = false;
          submitBtn.textContent = submitDefaultText;
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-image-search-root]').forEach(function (el) {
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();